module.exports = __webpack_public_path__ + "static/calloutLanguages-3d70f5eaad8706b1c8f4ff635290d682.jpg";